import React from "react";
import ShareButton from "../ShareButton";
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const SrmDescription = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    // Navigate with state indicating which section to focus
    navigate('/careers', {
      state: {
        focusSection: 'positions',
        skipScrolling: true
      }
    });
  };

  const jobData = {
    title: "Senior Relationship Manager",
    subtitle: "",
    department: "Wealth Management",
    jobType: "Full-Time",
    badgeText: "CAREER OPPORTUNITY",
    postedDays: 1,
    mailToAddress: "hr@maxiomwealth.com",

    // Job details
    location: {
      label: "Location",
      value: "Hyderabad & Bangalore (WFO)",
      cities: ["Hyderabad", "Bangalore"]
    },
    experience: {
      label: "Experience",
      value: "5+ years"
    },
    employment: {
      label: "Employment",
      value: "Full-time"
    },
    careerTrack: {
      label: "Joining",
      value: "Immediate to 1 month"
    },

    // Content sections
    roleOverview: {
      title: "Job Description",
      description: "Maxiom Wealth, a fintech leader transforming wealth management through AI and ML, is seeking a seasoned Senior Relationship Manager to join our dynamic team. We are looking for a client-centric individual with a proven track record of building and maintaining strong relationships with high-net-worth clients.",
      tag: "wealth-management"
    },
    responsibilities: {
      title: "Key Responsibilities",
      items: [
        "Cultivate and maintain deep relationships with high-net-worth clientele.",
        "Deliver tailored financial plans and investment recommendations aligned with client goals and risk tolerance.",
        "Leverage advanced AI analytics to create optimized investment portfolios for clients.",
        "Drive asset growth through client acquisition and retention.",
        "Stay at the forefront of market dynamics and industry best practices.",
        "Proactively monitor and enhance client portfolios through regular reviews."
      ]
    },
    desiredQualities: {
      title: "Ideal Candidate",
      items: [
        {
          title: "Experience",
          desc: "5+ years of experience in wealth management with a strong focus on client relationship management.",
          icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        },
        {
          title: "Knowledge",
          desc: "In-depth knowledge of financial products, investment strategies, and market trends.",
          icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
        },
        {
          title: "Certifications",
          desc: "Should have NISM V-A and NISM XXI A certifications.",
          icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        },
        {
          title: "Skills",
          desc: "Excellent communication, interpersonal, and presentation skills. Ability to analyze client data and provide data-driven recommendations.",
          icon: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        },
        {
          title: "Industry Knowledge",
          desc: "Strong understanding of the wealth management industry and regulatory landscape.",
          icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
        }
      ]
    },
    benefits: {
      title: "What's in it for you?",
      items: [
        {
          title: "Growth Opportunity",
          desc: "Join our high-growth startup and be part of shaping the future of wealth management.",
          icon: "M13 10V3L4 14h7v7l9-11h-7z"
        },
        {
          title: "Competitive Package",
          desc: "Enjoy a competitive compensation package including an attractive incentive structure.",
          icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        },
        {
          title: "ESOP Program",
          desc: "Benefit from our ESOP program and become a stakeholder in our success.",
          icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        },
        {
          title: "Career Growth",
          desc: "Opportunity to grow exponentially within a lean, dynamic team.",
          icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        }
      ]
    },

    // Job tags/badges
    jobTags: [
      {
        text: "Wealth Management",
        icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
        colorClass: "text-blue-300"
      },
      {
        text: "Client Relationship",
        icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
        colorClass: "text-purple-300"
      },
      {
        text: "Investment Advisory",
        icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
        colorClass: "text-pink-300"
      }
    ]
  };

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8 pt-20 sm:pt-36 md:pt-28 lg:pt-28">
      <div className="max-w-6xl mx-auto">
        {/* Back button */}
        <div className="mb-6">
          <button
            onClick={handleBackClick}
            className="flex items-center gap-1 sm:gap-2 text-orange-400 hover:text-orange-600 transition-all duration-300 font-medium text-xs sm:text-sm"
          >
            <ArrowLeft className="w-3 h-3 sm:w-4 sm:h-4" />
            <span className="text-sm sm:text-base">Back to Positions</span>
          </button>
        </div>

        {/* Premium Header with Accent Border */}
        <div className="relative bg-white rounded-xl sm:rounded-2xl shadow-md sm:shadow-xl overflow-hidden border border-gray-100">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></div>

          {/* Hero Section */}
          <div className="relative bg-slate-900 px-4 sm:px-6 md:px-8 py-10 sm:py-12 md:py-16">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-700"></div>
              <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")', backgroundSize: '30px 30px' }}></div>
            </div>

            <div className="relative z-10 max-w-3xl">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-900/30 text-blue-200 text-xs font-medium mb-4 backdrop-blur-sm">
                <span className="w-2 h-2 rounded-full bg-blue-400 mr-2"></span>
                {jobData.badgeText}
              </div>

              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 text-white leading-tight">
                {jobData.title} <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">{jobData.subtitle}</span>
              </h1>

              <p className="text-slate-300 text-base sm:text-lg mb-4 sm:mb-6 max-w-2xl">
                {jobData.department}
              </p>

              <div className="flex flex-wrap gap-2 sm:gap-3">
                {jobData.jobTags.map((tag, index) => (
                  <div key={index} className="inline-flex items-center px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg bg-white/10 backdrop-blur-sm text-white text-xs sm:text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-1.5 ${tag.colorClass}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={tag.icon} />
                    </svg>
                    {tag.text}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Content Container */}
          <div className="p-4 sm:p-6 md:p-8 lg:p-12">
            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 mb-8 sm:mb-12">
              {[
                { icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z", label: jobData.location.label, value: jobData.location.value },
                { icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z", label: jobData.experience.label, value: jobData.experience.value },
                { icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z", label: jobData.employment.label, value: jobData.employment.value },
                { icon: "M13 10V3L4 14h7v7l9-11h-7z", label: jobData.careerTrack.label, value: jobData.careerTrack.value }
              ].map((item, index) => (
                <div key={index} className="bg-slate-50 rounded-xl p-3 sm:p-4 flex flex-col">
                  <div className="flex items-center mb-1 sm:mb-2">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-slate-100 flex items-center justify-center mr-2 sm:mr-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 sm:h-4 sm:w-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                      </svg>
                    </div>
                    <span className="text-xs font-medium text-slate-500">{item.label}</span>
                  </div>
                  <span className="text-xs sm:text-sm md:text-base text-slate-800 font-medium">{item.value}</span>
                </div>
              ))}
            </div>

            {/* Role Description */}
            <section className="mb-8 sm:mb-12">
              <div className="flex items-start sm:items-center mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/20 mr-3 sm:mr-4 shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-slate-800">{jobData.roleOverview.title}</h2>
              </div>

              <div className="ml-0 sm:ml-16">
                <p className="text-slate-600 leading-relaxed text-sm sm:text-base md:text-lg mb-3 sm:mb-4">
                  {jobData.roleOverview.description}
                </p>
                <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs sm:text-sm font-medium">
                  {jobData.roleOverview.tag}
                </div>
              </div>
            </section>

            {/* Key Responsibilities */}
            <section className="mb-8 sm:mb-12">
              <div className="flex items-start sm:items-center mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/20 mr-3 sm:mr-4 shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                  </svg>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-slate-800">{jobData.responsibilities.title}</h2>
              </div>

              <div className="ml-0 sm:ml-16 grid gap-3 sm:gap-4">
                {jobData.responsibilities.items.map((item, index) => (
                  <div key={index} className="flex items-start group p-3 sm:p-4 rounded-lg hover:bg-slate-50 transition-colors">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mr-3 sm:mr-4 shrink-0 group-hover:bg-emerald-200 transition-colors">
                      <span className="font-medium text-xs sm:text-sm">{index + 1}</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-slate-700 font-medium text-sm sm:text-base">{item}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Desired Qualities */}
            <section className="mb-8 sm:mb-12">
              <div className="flex items-start sm:items-center mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg shadow-purple-500/20 mr-3 sm:mr-4 shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-slate-800">{jobData.desiredQualities.title}</h2>
              </div>

              <div className="ml-0 sm:ml-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {jobData.desiredQualities.items.map((item, index) => (
                    <div key={index} className="bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow p-4 sm:p-5 group">
                      <div className="flex items-center mb-2 sm:mb-3">
                        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center mr-3 group-hover:bg-purple-100 transition-colors shrink-0">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                          </svg>
                        </div>
                        <h3 className="font-semibold text-base sm:text-lg text-slate-800">{item.title}</h3>
                      </div>
                      <p className="text-slate-600 text-xs sm:text-sm ml-0 sm:ml-13">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* What You Can Expect */}
            <section className="mb-8 sm:mb-12">
              <div className="flex items-start sm:items-center mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/20 mr-3 sm:mr-4 shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                  </svg>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-slate-800">{jobData.benefits.title}</h2>
              </div>

              <div className="ml-0 sm:ml-16">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-amber-100/50">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    {jobData.benefits.items.map((item, index) => (
                      <div key={index} className="flex items-start">
                        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mr-3 sm:mr-4 shrink-0">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                          </svg>
                        </div>
                        <div>
                          <h3 className="font-medium text-slate-800 mb-1 text-sm sm:text-base">{item.title}</h3>
                          <p className="text-slate-600 text-xs sm:text-sm">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Location & Application */}
            <section className="border-t border-gray-200 pt-6 sm:pt-10 mt-8 sm:mt-12">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 sm:gap-8">
                <div>
                  <h2 className="text-lg sm:text-xl font-bold text-slate-800 mb-3 sm:mb-4">Location</h2>
                  <div className="flex flex-wrap gap-2 sm:gap-3">
                    {jobData.location.cities.map((city, index) => (
                      <div key={index} className="inline-flex items-center px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium bg-slate-100 text-slate-800 hover:bg-slate-200 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 sm:h-4 sm:w-4 mr-1.5 sm:mr-2 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {city}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col items-center lg:items-end">
                  <a
                    href={`mailto:${jobData.mailToAddress}`}
                    className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 border border-transparent text-sm sm:text-base font-medium rounded-xl text-white bg-[#113262] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-lg shadow-blue-500/30 transition-all transform hover:scale-105 w-full sm:w-auto"
                    onClick={() => window.open(`https://mail.google.com/mail/?view=cm&to=${jobData.mailToAddress}`, '_blank')}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Apply Now
                  </a>
                  <p className="text-xs sm:text-sm text-slate-500 mt-2 sm:mt-3 text-center lg:text-right">
                    Send your resume to {jobData.mailToAddress} with the opening in the subject
                  </p>
                </div>
              </div>
            </section>

            {/* Footer */}
            <div className="mt-8 sm:mt-12 pt-4 sm:pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center text-slate-500 text-xs sm:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span>Posted {jobData.postedDays} {jobData.postedDays === 1 ? 'day' : 'days'} ago</span>
              </div>

              <div className="flex space-x-2">
                <button className="p-2 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors" aria-label="Share">
                  <ShareButton />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SrmDescription;